import { Text, TextTypes, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Flex, IFlexProps, Pressable } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { useReportsActions } from '../../../../../../../store/customerDetail/reports/actions';
import {
  reportMarketOptionState,
  reportMonthSelectedOptionsState,
  reportYearBrokerageOptionState,
} from '../../../../../../../store/customerDetail/reports/atom';
import {
  currentReportYearOption,
  reportMarkets,
  reportsMonths,
  reportsYears,
} from '../../../../../../../store/customerDetail/reports/constants';

import { ReportFilterTypeProps } from '.';

interface ItemSelectProps {
  label: string;
  value: string;
  selectedOption: string | string[];
  handleSelect: (value: string) => void;
}

const textTitleStyle = {
  variant: 'semibold',
  fontSize: Typography['fontsize.md'],
} as TextTypes.Props;

const flexWrapperStyle = {
  flex: 1,
  direction: 'row' as const,
  style: { gap: 16 },
  flexWrap: 'wrap',
} as IFlexProps;

const ItemSelect = ({ label, value, handleSelect, selectedOption }: ItemSelectProps) => {
  const selectedOptionIsArray = Array.isArray(selectedOption);

  const itemIsSelected = selectedOptionIsArray
    ? selectedOption.includes(value)
    : selectedOption === value;

  return (
    <Pressable
      borderRadius={BoxRadius.md}
      borderWidth={'0.5px'}
      borderColor="neutral.dark"
      py={Spacing['stack.quarck']}
      px={Spacing['inline.xxxs']}
      onPress={() => handleSelect(value)}
      {...(itemIsSelected && { bg: 'brand.primary.principal' })}>
      <Text
        fontSize={Typography['fontsize.xs']}
        color={itemIsSelected ? 'neutral.white' : 'neutral.dark'}>
        {label}
      </Text>
    </Pressable>
  );
};

export const MonthPeriod: React.FC<ReportFilterTypeProps> = ({ incomeTaxBaseYearReports }) => {
  const reportMarketOption = useRecoilValue(reportMarketOptionState);
  const reportYearBrokerageYearOption = useRecoilValue(reportYearBrokerageOptionState);
  const reportMonthSelectedOptions = useRecoilValue(reportMonthSelectedOptionsState);

  const brokeragetOptionYearItems = [
    {
      label: String(currentReportYearOption),
      value: String(currentReportYearOption),
    },
    ...(incomeTaxBaseYearReports.data || []),
  ];

  const {
    updateReportMarketOption,
    updateReportYearBrokerageOption,
    updateReportMonthSelectedOption,
  } = useReportsActions();

  return (
    <VStack space={Spacing['stack.xxxs']}>
      <VStack space={Spacing['stack.xxxs']}>
        <Text {...textTitleStyle}>{reportMarkets.title.modal}</Text>
        <Flex {...flexWrapperStyle}>
          {reportMarkets.items.map((market) => (
            <ItemSelect
              {...market}
              key={market.label}
              selectedOption={reportMarketOption}
              handleSelect={(value) => updateReportMarketOption(value)}
            />
          ))}
        </Flex>
      </VStack>
      <VStack space={Spacing['stack.xxxs']}>
        <Text {...textTitleStyle}>{reportsYears.title.modal}</Text>
        <Flex {...flexWrapperStyle}>
          {brokeragetOptionYearItems?.map((year) => (
            <ItemSelect
              {...year}
              key={year.label}
              selectedOption={reportYearBrokerageYearOption}
              handleSelect={(value) => updateReportYearBrokerageOption(value)}
            />
          ))}
        </Flex>
      </VStack>
      <VStack space={Spacing['stack.xxxs']}>
        <Text {...textTitleStyle}>{reportsMonths.title.modal}</Text>
        <Flex {...flexWrapperStyle}>
          {reportsMonths.items.map((month) => (
            <ItemSelect
              {...month}
              key={month.label}
              handleSelect={(value) => updateReportMonthSelectedOption(value)}
              selectedOption={reportMonthSelectedOptions}
            />
          ))}
        </Flex>
      </VStack>
    </VStack>
  );
};
